import { ajax } from '@ifeng/ui_base';
import { get, post } from '../utils/request';

export const triggerSnapShot = async data => {
    await ajax('https://applet-snapshot.bomboom.cn/triggerMPSSnapShot', {
        data,
        type: 'post',
        cache: false,
    });
};

export const findSnapshot = async data => {
    const res = await ajax('https://applet-snapshot.bomboom.cn/findSnapshot', {
        data,
        type: 'post',
        cache: false,
    });

    return res;
};

export const createContent = async data => {
    const res = await post({
        url: '/content/create',
        params: data,
    });

    return res;
};

export const updateContent = async data => {
    const res = await post({
        url: '/content/update',
        params: data,
    });

    return res;
};

export const getImgLink = async ({ url }) => {
    const res = await get({
        url: `/cpdt/tempLink?url=${url}`,
    });

    return res;
};

// 获取当前圈子的标签
export const getTags = async ({ orgId, page = 1, size = 30 }) => {
    const res = await post({
        url: '/orgtag/page',
        params: {
            pages: {
                current: page,
                size,
            },
            where: { orgId },
        },
    });

    return res;
};

// 获取帖子详情
export const getEditInfo = async contentId => {
    const res = await get({
        url: `/content/edit/${contentId}`,
    });

    return res;
};

// 获取帖子是否是热门
export const getBoutique = async (contentId, orgId) => {
    const res = await post({
        url: '/orgcontent/one',
        params: {
            contentId,
            orgId,
        },
    });

    return res;
};

// 解析链接
export const linkAnalyze = async link => {
    const res = await get({
        url: `/outLink/handleOutLink?link=${encodeURIComponent(link)}`,
        config: {
            // eslint-disable-next-line no-undef
            basePath: linkBasePath,
            needCode: true,
        },
    });

    return res;
};
